import React, { useEffect, useState,useContext, useLayoutEffect } from "react";
import { Container, Col, Row, Tab, Tabs } from "react-bootstrap"; 
import URLstateContext from "../../../provider/CommonContext";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5percent from "@amcharts/amcharts5/percent";
import "./MFAssetsAllocation.css";
import SectorAllocationMF from "../SectorAllocationMF/SectorAllocationMF";



function MFAssetsAllocation(props) {
    const [chartyearsData, setyearschartData] = useState([]);
    const [chartdata, setchartdata] = useState([]);
    const [chartperiod, setchartperiod] = useState([]);
    const { MFcode } = useParams();

    let getMFCode = props.MFcode;
    let getcompname, getData;

    const { BaseURL } = useContext(URLstateContext);
    const [currentPage, setCurrentPage] = useState(1);
    let PageSize = 5;
    useEffect(() => {
        if(getMFCode != '') {
        const getUrl = BaseURL + "AllocationMF";
        // console.log(cocode)
        fetch(`${getUrl}/${getMFCode}`)
            // console.log(MFCode,"COCODE")
            .then((response) => response.json())
            .then((data) => {
                // console.log(data, "data");
                getData = data.data;
                setchartdata(getData);
                // console.log("data", getData);
            })
            .catch((error) => {
                // console.log("not found the api 1233333");
            });
        }
    }, [getMFCode]);

    useLayoutEffect(() => {
        var root = am5.Root.new("AssetAllocation");
        root.setThemes([
            am5themes_Animated.new(root)
        ]);
   
        var chart = root.container.children.push(am5percent.PieChart.new(root, {
            layout: root.verticalLayout
        }));

        var series = chart.series.push(am5percent.PieSeries.new(root, {
            valueField: "value",
            categoryField: "category",
            legendLabelText: "[fontSize: 13px]{category}:",
            legendValueText: "[fontSize: 13px]{value}%"
        }));

          function generateChartData() {
            let chartData = [];
            if (chartdata != null && chartdata != []) {
            for (var i = 0; i < chartdata.length; i++) {

                chartData.push({
                    category: chartdata[i].AssetName.replace(/[_]/g," "),
                    value: Number(chartdata[i].Holding_CurrentMonth)
                });
            }
        }
            return chartData;
        }
        let data = generateChartData();
          
        series.data.setAll(data);

        series.ticks.template.set("visible", false);
        series.labels.template.set("forceHidden", true);
        
        var legend = chart.children.push(am5.Legend.new(root, {
            centerY: am5.percent(50),
            x: am5.percent(30),
            layout: root.verticalLayout,
            dx: -20,
        }));
     
        legend.data.setAll(series.dataItems);

        series.appear(1000, 100);
         return () => {
            root.dispose();
        };
    }, [chartdata]);

  return (
   <>
   <section className="company-fundamental-sectionMF">
                <Container className="add-border table-boxAsset">
                    <Row>
                        <Col md={6}>
                            <h4>Assets Allocation</h4>
                            {chartdata == null ?  <h5 className="errormsgComNew"> No Data Found !!! </h5>:''}
                            <div id="AssetAllocation" style={{ width: "70%", height: "400px" }}></div>
                        </Col>
                        {/* <Col md={6}>
                          <SectorAllocationMF/>  
                        </Col>  */}
                    </Row>
                </Container>
    </section>

   </>
  )
}
export default MFAssetsAllocation;
